import React from 'react';
import styled from 'styled-components';
import palette from '../../lib/styles/palette';

const CardWrapper = styled.div`
    width: 100%;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    border: 1px solid #e0e4ea;
    overflow: hidden;
`;

const CardHeader = styled.div`
    padding: 18px 24px;
    background: #f8f9fb;
    border-bottom: 1px solid #e0e4ea;
`;

const CardTitle = styled.h3`
    margin: 0;
    font-size: 1.15rem;
    font-weight: 700;
    color: #2c3e50;
`;

const CardBody = styled.div`
    padding: 24px;
`;

export const SettingInfoBox = styled.div`
    width: 100%;
    display: flex;
    align-items: ${props => props.alignTop ? 'flex-start' : 'center'};
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`;

export const SettingInfoLabel = styled.div`
    width: 190px;
    min-width: 190px;
    font-size: 0.95rem;
    font-weight: 600;
    color: #3a4656;
    padding: ${props => props.noPadding ? '0' : '12px 0'};
`;

export const SettingInfoValue = styled.div`
    display: flex;
    flex: 1;
    font-size: 0.95rem;
    color: #555;
    align-items: center;
    flex-wrap: ${props => props.wrap ? 'wrap' : 'nowrap'};
`;

export const CardFooter = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid #e0e4ea;
`;

export const SaveButton = styled.button`
    background-color: ${props => props.active ? palette.webCyan[5] : '#fff'};
    color: ${props => props.active ? '#fff' : '#868e96'};
    border: 1px solid ${props => props.active ? palette.webCyan[5] : '#e0e4ea'};
    border-radius: 6px;
    padding: 10px 24px;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    font-size: 0.95rem;
    font-weight: 600;
    transition: all 0.15s ease;
    opacity: ${props => props.disabled ? 0.6 : 1};

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

const SettingCard = ({ title, children }) => {
    return (
        <CardWrapper>
            <CardHeader>
                <CardTitle>{title}</CardTitle>
            </CardHeader>
            <CardBody>
                {children}
            </CardBody>
        </CardWrapper>
    );
};

export default SettingCard;
